<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('bankProfile.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('bankProfile.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <div>
            <ts-button color="info" outline @click="addNew">{{
              $t('add_new')
            }}</ts-button>
          </div>
          <div>
            <div class="d-flex justify-content-between">
              <ts-input
                v-model="search"
                :placeholder="$t('search')"
                style="width: 250px"
                class="inline-block"
              />
              <ts-button
                outline
                class="ml-2"
                v-tooltip="$t('invoice.filter')"
                @click.prevent="visible = true"
              >
                <i class="fa fa-filter"></i>
              </ts-button>
            </div>
          </div>

          <!-- drawer -->
          <a-drawer
            :title="$t('invoice.filter')"
            placement="right"
            :closable="false"
            :visible="visible"
            @close="onCloseDrawer"
            :zIndex="1020"
            width="300px"
          >
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>{{ $t('invoice.branch') }}</label>
                  <a-select
                    style="width: 257px"
                    v-model="branch_id"
                    :options="branchs"
                    showSearch
                    mode="multiple"
                    :filterOption="filterOption"
                    :maxTagCount="1"
                    :maxTagTextLength="17"
                    :placeholder="$t('all')"
                  >
                  </a-select>
                </div>
              </div>
            </div>
          </a-drawer>
        </div>
      </ts-card-wrapper>
      <div class="ts-overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :expandable="true"
        >
          <template v-slot="{ record }">
            <td class="ts-whitespace-nowrap">
              {{ record.bank_name }}
            </td>
            <td class="ts-whitespace-nowrap">
              {{ record.bank_address }}
            </td>
            <td class="text-center ts-space-x-3 ts-whitespace-nowrap">
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="text-primary mr-2"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a-popconfirm
                placement="leftTop"
                :title="$t('are_you_sure_to_delete')"
                :ok-text="$t('yes')"
                :cancel-text="$t('no')"
                @confirm="deleteRecord(record)"
              >
                <a href="#" :disabled="record._deleting">
                  <i
                    class="fas fa-circle-notch spin"
                    v-if="record._deleting"
                  ></i>
                  <i class="fa fa-trash text-red" v-else></i>
                </a>
              </a-popconfirm>
            </td>
          </template>
          <div slot="expand" slot-scope="prop">
            <table class="ts-w-full ts-mx-auto detail">
              <thead>
                <tr class="ts-uppercase ts-bg-gray-200 ts-h-8 ts-text-white">
                  <th class="ts-pl-2 ts-whitespace-nowrap">
                    {{ $t('bankProfile.qrCode') }}
                  </th>
                  <th class="ts-pl-2 ts-whitespace-nowrap">
                    {{ $t('bankProfile.accountNumber') }}
                  </th>
                  <th class="ts-pl-2 ts-whitespace-nowrap">
                    {{ $t('bankProfile.accountName') }}
                  </th>
                  <th class="ts-pl-2 ts-whitespace-nowrap">
                    {{ $t('bankProfile.swiftCode') }}
                  </th>
                  <th class="ts-pl-2">
                    {{ $t('bankProfile.remark') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="ts-border-b-2"
                  v-for="(detail, index) in prop.record.bank_accounts"
                  :key="index"
                >
                  <td class="ts-p-2 ts-whitespace-nowrap">
                    <img
                      class="height-30 ts-rounded"
                      v-lazy="{
                        src: qrCode(detail),
                        loading: require('@/assets/Rolling-1s-200px_2.svg')
                      }"
                    />
                  </td>
                  <td class="ts-p-2 ts-whitespace-nowrap">
                    {{ detail.account_number }}
                  </td>
                  <td class="ts-p-2 ts-whitespace-nowrap">
                    {{ detail.account_name }}
                  </td>
                  <td class="ts-p-2 ts-whitespace-nowrap">
                    {{ detail.swift_code }}
                  </td>
                  <td class="ts-p-2 ts-whitespace-nowrap">
                    {{ detail.remarks }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>

    <a-modal
      v-if="showForm"
      v-model="showForm"
      :title="$t('bankProfile.pageTitle')"
      centered
      :maskClosable="false"
      @cancel="clearEdit"
      :footer="null"
      width="1000px"
    >
      <from-action @cancel="clearEdit" />
    </a-modal>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FromAction from './form.vue'
export default {
  name: 'bankProfileIndex',
  components: {
    FromAction
  },
  data() {
    return {
      visible: false,
      loading: false,
      showForm: false,
      branchs: [],
    }
  },
  computed: {
    ...mapState('bankProfile', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.bankProfile.search
      },
      set(newValue) {
        this.$store.commit('bankProfile/SET_SEARCH', newValue)
        this.$store.commit('bankProfile/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          name: this.$t('bankProfile.bankName'),
          style: 'white-space: nowrap;width:21%'
        },
        {
          name: this.$t('bankProfile.bankAddress'),
          style: 'white-space: nowrap;width:71%'
        },
        {
          name: this.$t('actions'),
          style: 'text-align:center; width: 1px;'
        }
      ]
    },
    branch_id: {
      get() {
        return this.$store.state.bankProfile.branch_id
      },
      set(newValue) {
        this.$store.commit('bankProfile/SET_BRANCH_ID', newValue)
      }
    },
  },
  mounted() {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.getBranch()
  },
  methods: {
    qrCode(record) {
      if (record.image_qr_code) {
        return '/api/files?filePath=' + record.image_qr_code
      }
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('bankProfile/fetch', { ...attributes })
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$notify({ type: 'error', text: error.message })
        })
    },
    addNew() {
      this.showForm = true
    },
    edit(record) {
      this.$store.commit('bankProfile/SET_EDIT_DATA', record)
      this.showForm = true
    },
    clearEdit() {
      this.$store.commit('bankProfile/SET_EDIT_DATA', {})
      this.showForm = false
      this.fetchData()
    },
    deleteRecord(record) {
      record._deleting = true
      this.$store
        .dispatch('bankProfile/destroy', record.bank_id)
        .then(response => {
          this.fetchData()
          this.$toasted.success(response.message)
        })
        .catch(error => {
          this.$notify({ type: 'error', text: error.message })
        })
    },
    getBranch() {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    onCloseDrawer() {
      this.visible = false
    },
    filterOption(input, option) {
      return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
  },
  watch: {
    search: debounce(function() {
      this.fetchData()
    }, 500),
    branch_id: debounce(function() {
      this.fetchData()
    }, 500),
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('bankProfile/RESET_STATE')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
